import React, { Fragment } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Header from '../../../components/header';
import Head from '../../../components/head';
import Footer from '../../../components/footer';
import ListaLicitacoesExpo23 from '../../../components/licitacao/listar/expomacuco';


function ListaLicitacoesExpo23Screen() {
    return (
        <Fragment>
            <Head titulo="Licitações realizadas para a Expo Macuco 2023" />
            <Header />
            <Container>
                <ListaLicitacoesExpo23 />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default ListaLicitacoesExpo23Screen;